import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

/* COURSE SCHEDULES */

domReady(() => {
  const select = document.querySelector('#courseScheduleSelection');
  const schedules = document.querySelectorAll('.courseScheduleItem');

  const updateSchedules = (value) => {
    schedules.forEach((schedule) => {
      if (value === schedule.getAttribute('data-program')) {
        schedule.classList.add('active');
      } else {
        schedule.classList.remove('active');
      }
    });
  };

  if (select) {
    select.addEventListener('change', (e) => {
      updateSchedules(e.target.value);
    });

    window.addEventListener('pageshow', () => {
      updateSchedules(select.value);
    });
  }
});

/* RELATED PROGRAMS TOGGLE */

domReady(() => {
  const toggleBtn = document.querySelector('.courseTogglePrograms');
  const extraItems = document.querySelectorAll(
    '.courseProgramsList .extraItem'
  );

  if (toggleBtn && 0 < extraItems.length) {
    toggleBtn.addEventListener('click', () => {
      if (toggleBtn.classList.contains('expanded')) {
        toggleBtn.classList.remove('expanded');
        toggleBtn.textContent = _x(
          'Show more',
          'course toggle programs button',
          'vtx'
        );
        extraItems.forEach((item) => {
          item.style.display = 'none';
        });
      } else {
        toggleBtn.classList.add('expanded');
        toggleBtn.textContent = _x(
          'Show less',
          'course toggle programs button',
          'vtx'
        );
        extraItems.forEach((item) => {
          item.style.display = 'block';
        });
      }
    });
  }
});
